<template>
  <div>
    <heads title="注册"></heads>
    <!-- 注册页面 -->
    <div class="page">
      <!-- 内容盒子 -->
      <div class="login-content">
        <!-- 标题 -->
        <div class="content-title">
          <p class="title-p">注册账号</p>
          <p class="title-box" @click="nowLoginButton">
            <span>已有账号，</span>
            <span>立即登录</span>
            <el-icon>
              <ArrowRight />
            </el-icon>
          </p>
        </div>

        <!-- 单选框+输入框盒子 -->
        <div class="some-input">
          <!-- 注册身份单选框 -->
          <el-form
            style="max-width: 343px"
            label-width="auto"
            class="demo-ruleForm"
            ref="formEl"
            :model="mydata.form"
            :rules="mydata.rules"
            label-position="top"
          >
            <el-form-item label="注册身份" class="id-box" prop="user_role">
              <el-radio-group
                v-model="mydata.form.user_role"
                @change="radioChange"
              >
                <el-radio value="3" size="large">老师</el-radio>
                <el-radio value="1" size="large">学生</el-radio>
                <el-radio value="2" size="large">家长</el-radio>
                <el-radio value="5" size="large">商家</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 老师 -->
            <template v-if="mydata.form.user_role === '3'">
              <el-form-item label="昵称" prop="nickname">
                <el-input
                  v-model="mydata.form.nickname"
                  placeholder="请填写您的昵称"
                />
              </el-form-item>

              <el-form-item label="所在省份/城市" prop="provinceAndCityArr">
                <el-cascader
                  :options="pcTextArr"
                  v-model="mydata.form.provinceAndCityArr"
                  placeholder="请选择您所在的省份/城市"
                >
                </el-cascader>
              </el-form-item>

              <el-form-item label="学校" prop="school">
                <el-input
                  v-model="mydata.form.school"
                  placeholder="请填写您的学校"
                />
              </el-form-item>
              
              <el-form-item label="学科" prop="subject">
                <el-input
                  v-model="mydata.form.subject"
                  placeholder="请填您的学科"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>

              <el-form-item label="教授学段" prop="teachGradeId">
                <!-- <el-input
                v-model="mydata.form.gradeId"
                placeholder="请填你的年级"
              /> -->
                <el-select
                  v-model="mydata.form.teachGradeId"
                  placeholder="请选择您的教授学段"
                >
                  <el-option
                    v-for="item in mydata.study_stageOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password"
                  placeholder="密码长度为8-16位，须使用数字、字母大/小写组合"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>
              <el-form-item label="确认密码" prop="password_confirm">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password_confirm"
                  placeholder="请重复输入密码"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>

              <!-- 因手机号验证有bug 所以以下邮箱验证只是暂时使用 -->
              <!-- <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item> -->
              <!-- 因手机号验证有bug 所以以下需要暂时注释 -->
              <!-- ----------------------------- -->
              <!--手机号验证 或  邮箱验证任选其一-->
              <el-form-item
                label="验证方式"
                class="id-box cs-box"
                prop="authentication_methods"
              >
                <el-radio-group v-model="mydata.form.authentication_methods"  @change="codeRadioChange">
                  <el-radio value="1" size="large">手机号验证</el-radio>
                  <el-radio value="2" size="large">邮箱验证</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 手机号验证 -->
              <template v-if="mydata.form.authentication_methods === '1'">
                <el-form-item label="手机号码" prop="phone">
                  <el-input
                    v-model="mydata.form.phone"
                    placeholder="请填写您的手机号码"
                  />
                </el-form-item>

                <el-form-item label="手机验证码" prop="phone_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.phone_code"
                    placeholder="手机验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode"
                    :disabled="mydata.btnDisabled"
                    >{{ mydata.btnText }}</el-button
                  >
                </el-form-item>
              </template>
              <!-- 邮箱验证 -->
              <template v-if="mydata.form.authentication_methods === '2'">
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item>
              </template>
            </template>

            <!-- 学生 -->
            <template v-if="mydata.form.user_role === '1'">
              <el-form-item label="昵称" prop="nickname">
                <el-input
                  v-model="mydata.form.nickname"
                  placeholder="请填写您的昵称"
                />
              </el-form-item>

              <el-form-item label="所在省份/城市" prop="provinceAndCityArr">
                <el-cascader
                  :options="pcTextArr"
                  v-model="mydata.form.provinceAndCityArr"
                  placeholder="请选择您所在的省份/城市"
                >
                </el-cascader>
              </el-form-item>

              <el-form-item label="学校" prop="school">
                <el-input
                  v-model="mydata.form.school"
                  placeholder="请填写您的学校"
                />
              </el-form-item>

              <el-form-item label="年级" prop="gradeId">
                <!-- <el-input
                v-model="mydata.form.gradeId"
                placeholder="请填你的年级"
              /> -->
                <el-select
                  v-model="mydata.form.gradeId"
                  placeholder="请选择您的年级"
                >
                  <el-option
                    v-for="item in mydata.gradeIdOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password"
                  placeholder="密码长度为8-16位，须使用数字、字母大/小写组合"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>
              <el-form-item label="确认密码" prop="password_confirm">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password_confirm"
                  placeholder="请重复输入密码"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>
              
              <!-- 因手机号验证有bug 所以以下邮箱验证只是暂时使用 -->
              <!-- <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item> -->
 
              <!-- 因手机号验证有bug 所以以下需要暂时注释 -->
              <!-- ----------------------------- -->
              <!--手机号验证 或  邮箱验证任选其一-->
              <el-form-item
                label="验证方式"
                class="id-box cs-box"
                prop="authentication_methods"
              >
                <el-radio-group v-model="mydata.form.authentication_methods"  @change="codeRadioChange">
                  <el-radio value="1" size="large">手机号验证</el-radio>
                  <el-radio value="2" size="large">邮箱验证</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 手机号验证 -->
              <template v-if="mydata.form.authentication_methods === '1'">
                <el-form-item label="手机号码" prop="phone">
                  <el-input
                    v-model="mydata.form.phone"
                    placeholder="请填写您的手机号码"
                  />
                </el-form-item>

                <el-form-item label="手机验证码" prop="phone_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.phone_code"
                    placeholder="手机验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode"
                    :disabled="mydata.btnDisabled"
                    >{{ mydata.btnText }}</el-button
                  >
                </el-form-item>
              </template>
              <!-- 邮箱验证 -->
              <template v-if="mydata.form.authentication_methods === '2'">
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item>
              </template>
            </template>

            <!-- 家长 -->
            <template v-if="mydata.form.user_role === '2'">
              <el-form-item label="您最关注" class="id-box" prop="study_stage">
                <el-radio-group v-model="mydata.form.study_stage">
                  <!-- <el-radio value="7" size="large">小升初</el-radio>
                <el-radio value="10" size="large">中考</el-radio>
                <el-radio value="8" size="large">高考</el-radio> -->
                  <el-radio
                    v-for="item in mydata.study_stageOptions"
                    :key="item.id"
                    :value="item.id"
                    size="large"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item label="昵称" prop="nickname">
                <el-input
                  v-model="mydata.form.nickname"
                  placeholder="请填写您的昵称"
                />
              </el-form-item>

              <el-form-item label="所在省份/城市" prop="provinceAndCityArr">
                <el-cascader
                  :options="pcTextArr"
                  v-model="mydata.form.provinceAndCityArr"
                  placeholder="请选择您所在的省份/城市"
                >
                </el-cascader>
              </el-form-item>

              
              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password"
                  placeholder="密码长度为8-16位，须使用数字、字母大/小写组合"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>
              <el-form-item label="确认密码" prop="password_confirm">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password_confirm"
                  placeholder="请重复输入密码"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>
              
              <!-- 因手机号验证有bug 所以以下邮箱验证只是暂时使用 -->
              <!-- <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item> -->
             
              <!-- 因手机号验证有bug 所以以下需要暂时注释 -->
              <!-- ----------------------------- -->
              <!--手机号验证 或  邮箱验证任选其一-->
              <el-form-item
                label="验证方式"
                class="id-box cs-box"
                prop="authentication_methods"
              >
                <el-radio-group v-model="mydata.form.authentication_methods"  @change="codeRadioChange">
                  <el-radio value="1" size="large">手机号验证</el-radio>
                  <el-radio value="2" size="large">邮箱验证</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 手机号验证 -->
              <template v-if="mydata.form.authentication_methods === '1'">
                <el-form-item label="手机号码" prop="phone">
                  <el-input
                    v-model="mydata.form.phone"
                    placeholder="请填写您的手机号码"
                  />
                </el-form-item>

                <el-form-item label="手机验证码" prop="phone_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.phone_code"
                    placeholder="手机验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode"
                    :disabled="mydata.btnDisabled"
                    >{{ mydata.btnText }}</el-button
                  >
                </el-form-item>
              </template>
              <!-- 邮箱验证 -->
              <template v-if="mydata.form.authentication_methods === '2'">
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item>
              </template>
            </template>

            <!-- ===================================== -->
            <!-- 商家 -->
            <template v-if="mydata.form.user_role === '5'">
              <el-form-item label="店铺名称" prop="store_name">
                <el-input
                  v-model="mydata.form.store_name"
                  placeholder="请填写您的店铺名称"
                />
              </el-form-item>

              <el-form-item label="昵称" prop="nickname">
                <el-input
                  v-model="mydata.form.nickname"
                  placeholder="请填写您的昵称"
                />
              </el-form-item>

              <el-form-item label="所在省份/城市" prop="provinceAndCityArr">
                <el-cascader
                  :options="pcTextArr"
                  v-model="mydata.form.provinceAndCityArr"
                  placeholder="请选择您所在的省份/城市"
                >
                </el-cascader>
              </el-form-item>

              <el-form-item label="密码" prop="password">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password"
                  placeholder="密码长度为8-16位，须使用数字、字母大/小写组合"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>
              <el-form-item label="确认密码" prop="password_confirm">
                <el-input
                  type="password"
                  show-password
                  v-model="mydata.form.password_confirm"
                  placeholder="请重复输入密码"
                  @focus="mydata.readonlyInput = false"
                  :readonly="mydata.readonlyInput"
                />
              </el-form-item>
              
              <!-- 因手机号验证有bug 所以以下邮箱验证只是暂时使用 -->
              <!-- <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item> -->
              <!-- 因手机号验证有bug 所以以下需要暂时注释 -->
              <!-- ----------------------------- -->
              <!--手机号验证 或  邮箱验证任选其一-->
              <el-form-item
                label="验证方式"
                class="id-box cs-box"
                prop="authentication_methods"
              >
                <el-radio-group v-model="mydata.form.authentication_methods"  @change="codeRadioChange">
                  <el-radio value="1" size="large">手机号验证</el-radio>
                  <el-radio value="2" size="large">邮箱验证</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 手机号验证 -->
              <template v-if="mydata.form.authentication_methods === '1'">
                <el-form-item label="手机号码" prop="phone">
                  <el-input
                    v-model="mydata.form.phone"
                    placeholder="请填写您的手机号码"
                  />
                </el-form-item>

                <el-form-item label="手机验证码" prop="phone_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.phone_code"
                    placeholder="手机验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode"
                    :disabled="mydata.btnDisabled"
                    >{{ mydata.btnText }}</el-button
                  >
                </el-form-item>
              </template>
              <!-- 邮箱验证 -->
              <template v-if="mydata.form.authentication_methods === '2'">
                <el-form-item label="邮箱" prop="email">
                  <el-input
                    v-model="mydata.form.email"
                    placeholder="请填写您的邮箱"
                  />
                </el-form-item>
                <el-form-item label="邮箱验证码" prop="email_code">
                  <el-input
                    class="mobile-code"
                    v-model="mydata.form.email_code"
                    placeholder="邮箱验证码"
                  />
                  <el-button
                    class="password-button"
                    @click="getCode2"
                    :disabled="mydata.btnDisabled2"
                    >{{ mydata.btnText2 }}</el-button
                  >
                </el-form-item>
              </template>
            </template>
            <!-- ===================================== -->
          </el-form>
        </div>

        <!-- 提交按钮 + 已读勾选框 盒子 -->
        <div class="last-box">
          <!-- 提交按钮 -->
          <el-button type="primary" @click="submit">同意协议并注册</el-button>
          <!-- 是否已读  -->
          <div class="login-checkbox">
            <el-checkbox v-model="mydata.protocolchecked" size="large">
              <!-- <p class="text"> -->
              我已阅读并同意
              <!-- </p> -->
            </el-checkbox>
            <span
              @click="agreementClick('user_agreement')"
              style="cursor: pointer"
              >《用户协议》</span
            >
            <span>和</span>
            <span
              @click="agreementClick('privacy_agreement')"
              style="cursor: pointer"
              >《隐私协议》</span
            >
          </div>
        </div>

        <!-- 弹窗(协议) -->
        <el-dialog class="agreement-box" v-model="mydata.dialog" width="343">
          <div>
            <p v-html="mydata.getAgreementObj"></p>
          </div>
        </el-dialog>
      </div>
    </div>
    <lastBar></lastBar>
    <!-- <bottomBar class="bottomBar"></bottomBar> -->
  </div>
</template>

<script setup>
import heads from "@/components/heads/index.vue";
import lastBar from "@/components/lastBar/index.vue";

import { ArrowRight } from "@element-plus/icons-vue";
import { ref, reactive, toRefs, provide } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import bottomBar from "@/components/bottomBar/index.vue";
//验证是否为手机号
import { isPhoneNumber, isEmail } from "@/utils/validate.js";
// 引入手机号验证码发送接口
import { sendPhonCode } from "@/api/login/retrievePasswordLogin/index.js";
// 引入接口
import {
  register,
  get_grade_group,
  get_grade,
} from "@/api/login/nowLogin/index.js";
import { pcTextArr } from "element-china-area-data";
import { emailLogin } from "@/api/login/retrievePasswordLogin/index.js";
import { getConfig } from "@/api/list/index.js";

// 引入接口
import { getAgreement } from "@/api/login/nowLogin/index.js";

const router = useRouter();
const formEl = ref(null);
const mydata = reactive({
  btnText: "获取验证码",
  btnText2: "获取验证码",
  btnDisabled: false,
  btnDisabled2: false,
  // 单选框的值
  radioValue: "1",
  size: "default",
  protocolchecked: false,
  upload: {
    dialogImageUrl: "",
    dialogVisible: "",
    disabled: false,
  },
  provinceType2: JSON.parse(localStorage.getItem("provinceType2")) ?? [],
  /* 
    高一、高二、高三跳转至“图书介绍→高中书系”，
    初一、初二、初三跳转至“图书介绍→初中书系”，
    一年级、二年级、三年级、四年级、五年级、六年级跳转时“图书介绍→小学书系”。
  */
  gradeIdOptions: [
    // {
    //   label: "一年级",
    //   value: "一年级",
    // },
    // {
    //   label: "二年级",
    //   value: "二年级",
    // },
    // {
    //   label: "三年级",
    //   value: "三年级",
    // },
    // {
    //   label: "四年级",
    //   value: "四年级",
    // },
    // {
    //   label: "五年级",
    //   value: "五年级",
    // },
    // {
    //   label: "六年级",
    //   value: "六年级",
    // },
    // {
    //   label: "初一",
    //   value: "初一",
    // },
    // {
    //   label: "初二",
    //   value: "初二",
    // },
    // {
    //   label: "初三",
    //   value: "初三",
    // },
    // {
    //   label: "高一",
    //   value: "高一",
    // },
    // {
    //   label: "高二",
    //   value: "高二",
    // },
    // {
    //   label: "高三",
    //   value: "高三",
    // },
  ],
  study_stageOptions: [],
  form: {
    provinceAndCityArr: [],
    user_role: "3", //注册身份{1:学生,2:教师家长,3:教师}

    study_stage: "", //最关注的是
    authentication_methods: "1", //验证方式{1:手机号,2:邮箱}
    password_confirm: "", //确认密码

    nickname: "", //姓名
    province: "", // 省
    city: "", //市
    school: "", //学校
    teachGradeId: "", //教授学段
    gradeId: "", //年级
    subject: "", // 学科
    phone: "", //手机号
    phone_code: "", //验证码
    password: "", //密码
    email: "", //邮箱
    email_code: "", //邮箱验证码

    store_name: "", //店铺名称
  },
  rules: {
    study_stage: [
      {
        required: true,
        message: "请选择您最关注的信息", //////无字段
      },
    ],

    authentication_methods: [
      {
        required: true,
        message: "请选择验证方式", //////无字段
      },
    ],

    password_confirm: [
      {
        required: true,
        message: "请重复输入密码", //////无字段
      },
      {
        validator: validator_password_confirm,
      },
    ],

    provinceAndCityArr: [
      {
        required: true,
        message: "请选择您所在的省份/城市",
        trigger: "change",
      },
    ],
    user_role: [
      {
        required: true,
        message: "请选择身份",
      },
    ],
    nickname: [
      {
        required: true,
        message: "请填写您的昵称",
      },
    ],
    province: [
      {
        required: true,
        message: "请选择您的省份",
        trigger: "change",
      },
    ],

    school: [
      {
        required: true,
        message: "请填写您的学校",
      },
    ],
    teachGradeId: [
      {
        required: true,
        message: "请选择您的教授学段",
        trigger: "change",
      },
    ],

    gradeId: [
      {
        required: true,
        message: "请选择您的年级",
        trigger: "change",
      },
    ],
    subject: [
      {
        required: true,
        message: "请填写您的学科",
      },
    ],
    phone: [
      {
        required: true,
        message: "请填写您的电话号码",
      },
      { min: 11, max: 11, message: "请输入11位电话号码", trigger: "blur" },
    ],

    phone_code: [
      {
        required: true,
        message: "请填写手机验证码",
      },
    ],

    password: [
      {
        required: true,
        message: "密码长度为8-16位，须使用数字、字母大/小写组合",
      },
      {
        validator: validator_password,
      },
    ],
    email: [
      {
        required: true,
        message: "请填写您的邮箱",
      },
    ],
    email_code: [
      {
        required: true,
        message: "请填写邮箱验证码",
      },
    ],
    store_name: [
      {
        required: true,
        message: "请填写店铺名称",
      },
    ],
  },
  checked1: false,
  btnLoading: false,
  configObj: {},
  readonlyInput: false,

  name: "", 
  
  //  隐私协议 privacy_agreement      用户协议 user_agreement
  getAgreementObj: {}, //获取协议内容
  dialog: false,
});

function codeRadioChange(){
  // 手机
  mydata.form.phone=''
  mydata.form.phone_code=''
  clearInterval(intervalId);
  mydata.btnDisabled = false;
  mydata.btnText = "获取验证码";
  // 邮箱
  mydata.form.email=''
  mydata.form.email_code=''
  clearInterval(intervalId2);
  mydata.btnDisabled2 = false;
  mydata.btnText2 = "获取验证码";
}


//获取协议内容
function agreementClick(val) {
  mydata.name = val;
  getAgreement({ name: mydata.name }).then((res) => {
    // console.log(res);
    mydata.getAgreementObj = res.data;
    mydata.dialog = true;
  });
}

function validator_password(rule, value, callback) {
  if (mydata.form.password_confirm !== "") {
    // 手动验证重复输入密码的值
    formEl.value.validateField("password_confirm");
  }
  let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,16}$/;
  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error("密码长度为8-16位，须使用数字、字母大/小写组合"));
  }
}

function validator_password_confirm(rule, value, callback) {
  if (mydata.form.password === value) {
    callback();
  } else {
    callback(new Error("两次密码不一致"));
  }
}

let intervalId = null;
let intervalId2 = null;

function radioChange(val) {
  // 清空内容
  mydata.form = {
    provinceAndCityArr: [],
    user_role: "", //注册身份{1:学生,2:教师家长,3:教师}

    study_stage: "", //最关注的是
    authentication_methods: "1", //验证方式{1:手机号,2:邮箱}
    password_confirm: "", //确认密码

    nickname: "", //姓名
    province: "", // 省
    city: "", //市
    school: "", //学校
    teachGradeId: "", //教授学段
    gradeId: "", //年级
    subject: "", // 学科
    phone: "", //手机号
    phone_code: "", //验证码
    password: "", //密码
    email: "", //邮箱
    email_code: "", //邮箱验证码

    store_name:"",//店铺名称
  };
  // 清除定时器
  clearInterval(intervalId);
  clearInterval(intervalId2);
  // 设置单选框的值
  mydata.form.user_role = val;
  // 设置内容
  mydata.btnText = "获取验证码";
  mydata.btnText2 = "获取验证码";
  mydata.btnDisabled = false;
  mydata.btnDisabled2 = false;
  // 清楚某个表单字段的校验状态
  setTimeout(() => {
      formEl.value.clearValidate()
  }, 0);
}

//获取验证码,按钮点击事件
function getCode() {
  // 如果不是手机号，那么提醒弹窗并终止代码
  if (isPhoneNumber(mydata.form.phone) === false) {
    ElMessage({
      message: "手机号码格式错误",
      type: "warning",
    });
    return;
  }

  mydata.btnDisabled = true;
  let num = 60;
  intervalId = setInterval(() => {
    num = num - 1;
    mydata.btnText = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    }
  }, 1000);

  // 调用sendPhonCode方法，发送请求
  sendPhonCode({
    phone: mydata.form.phone,
  })
    .then((res) => {
      // console.log(res.data,"手机号获取验证码")
      // 存储后端返回的用户信息
      // localStorage.setItem("userInfo", JSON.stringify(res.data));
      // // 提示弹窗
      ElMessage({
        message: res.msg,
        type: "success",
      });
    })
    .catch((err) => {
      mydata.btnText = "获取验证码";
      clearInterval(intervalId);
      mydata.btnDisabled = false;
    });
}

//获取验证码,按钮点击事件
function getCode2() {
  // 如果不是手机号，那么提醒弹窗并终止代码
  if (isEmail(mydata.form.email) === false) {
    ElMessage({
      message: "邮箱格式错误",
      type: "warning",
    });
    return;
  }

  mydata.btnDisabled2 = true;
  let num = 60;
  intervalId2 = setInterval(() => {
    num = num - 1;
    mydata.btnText2 = num + "秒后可重发";
    if (num === 0) {
      mydata.btnText2 = "获取验证码";
      clearInterval(intervalId2);
      mydata.btnDisabled2 = false;
    }
  }, 1000);

  // 调用emailLogin方法，发送请求
  emailLogin({
    email: mydata.form.email,
  })
    .then((res) => {
      // console.log(res.data,"手机号获取验证码")
      // 存储后端返回的用户信息
      // localStorage.setItem("userInfo", JSON.stringify(res.data));
      // // 提示弹窗
      ElMessage({
        message: res.msg,
        type: "success",
      });
    })
    .catch((err) => {
      mydata.btnText2 = "获取验证码";
      clearInterval(intervalId2);
      mydata.btnDisabled2 = false;
    });
}

//登录的事件函数
function submit() {
  // 如果没有勾选协议
  if (!mydata.protocolchecked) {
    // 提示弹窗
    ElMessage({
      message: "请在勾选协议后进行注册或登录",
      type: "warning",
    });
    // 终止执行
    return;
  }

  // console.log(mydata.form);

  formEl.value.validate((v) => {
    if (v) {
      register({
        ...mydata.form,
        province: mydata.form.provinceAndCityArr[0],
        city: mydata.form.provinceAndCityArr[1],
      }).then((res) => {
        // 提示弹窗
        // ElMessage({
        //   message: res.msg,
        //   type: "success",
        // });
        ElMessage({
          message: `
          <span>${res.msg}</span>
          <span style="margin-left:10px;font-weight:bold;">【请在个人中心页面完成实名认证】</span>
          `,
          type: "success",
          dangerouslyUseHTMLString: true,
        });
        // // 跳转页面
        router.push({
          path: "/login/nowLogin",
        });
      });
    }
  });

  // 调用login方法，发送请求
  // login({
  //   account: mydata.form.nickname,
  //   password: mydata.form.password,
  // }).then((res) => {
  //   console.log(res.data,"用户信息")
  //   // 存储后端返回的用户信息
  //   localStorage.setItem("userInfo", JSON.stringify(res.data));
  //   // 提示弹窗
  //   ElMessage({
  //     message: '注册成功',
  //     type: "success",
  //   });
  //   // 跳转页面
  //   router.push({
  //     path: "/login.nowLogin",
  //   });
  // });
}

//已有账号，立即登录
function nowLoginButton() {
  router.push({
    path: "/login/nowLogin",
  });
}

function goHome() {
  router.push({
    path: "/layout/list/home",
  });
}

// 获取配置数据
function getConfigFn() {
  getConfig().then((res) => {
    mydata.configObj = res.data;
  });
}

getConfigFn();

// 依赖注入
provide("configObj", toRefs(mydata).configObj);

// function handleClick(tab) {
//   console.log(tab);
// }

//按钮的事件函数
// function submit() {

// console.log(mydata.zhanghao, mydata.mima);
// mydata.btnLoading = true;
// axios({
//   method: "post",
//   url: "/house/login/login",
//   data: {
//     //请求参数（get请求的时候必须用params，post请求的时候必须用data）
//     account: mydata.zhanghao,
//     password: mydata.mima,
//     // sourceText: mydata.zhanghao + mydata.mima, //sourceText就是这次项目的后端跟你说的必须用什么属性名，否则后端就拿不到了；属性值是我要传给后端的内容
//   },
// }).then((res) => {
//   mydata.btnLoading = false;
//   if (res.data.code === 1) {
//     ElMessage({
//       message: res.msg,
//       type: "success",
//     });

//     // 存储后端返回的token值
//     localStorage.setItem("token", res.data.data.token);
//     localStorage.setItem("adminName", mydata.zhanghao);

//     // 跳转页面
//     router.push({
//       path: "/layout/list/personalCenter/personalInfor/index.vue",
//     });

//     mydata.zhanghao = "";
//     mydata.mima = "";
//   }
// });
// }

function init() {
  get_grade_group().then((res) => {
    mydata.study_stageOptions = res.data;
  });
  get_grade().then((res) => {
    mydata.gradeIdOptions = res.data;
  });
}

init();
</script>

<style scoped lang="scss">
.page {
  // width: 1915px;
  // height: 100vh;
  // min-height: 900px;
  // background-image: url("@/assets/logo.png");
  // background-color: #ddeffd !important;
  overflow: hidden;
  // height:calc(100vh - 50px);
  // border:1px solid red;
  // background-size: 1440px auto;
  // background-size: 100% auto;
  // background-repeat: no-repeat;
  // background-position: center bottom;

  //内容盒子
  .login-content {
    margin: 0 auto;
    // margin-top: 30px;
    padding: 16px 16px 40px 16px;
    background-color: #ffffff;
    box-shadow: 0px 5px 40px 0px #0000000d;
    border-radius: 8px;

    ////// 标题
    .content-title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      // border: 1px solid red;
      .title-p {
        font-size: 18px;
        font-weight: 700;
        color: #282828;
      }

      .title-box {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #282828;
        cursor: pointer;

        span:nth-of-type(2) {
          color: #009de0;
        }
      }
    }

    ////// 单选框 + 输入框 盒子 ////////////////////////////////////
    .some-input {
      // width: 556px;
      // border: 1px solid blue;
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 20px;
      overflow: hidden;

      :deep(.el-form-item) {
        // flex-direction: column;
        .el-input__wrapper {
          height: 40px;
        }
      }

      :deep(.el-select__wrapper.el-tooltip__trigger.el-tooltip__trigger) {
        height: 40px;
      }

      :deep(.el-form-item__label-wrap) {
        // margin-left: 0px !important;
      }

      //选择身份
      :deep(.el-form-item.is-required.asterisk-left.id-box) {
        margin-bottom: 16px;
        .el-form-item__content {
          .el-radio.el-radio--large {
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            .el-radio__inner {
              width: 20px;
              height: 20px;
              // border-color:#666666;
            }
          }
        }
      }

      //密码框后的小眼睛
      :deep(.el-icon.el-input__icon.el-input__password) {
        font-size: 20px;
        // color:blue;
      }

      //下拉框、输入框 、textarea框 的长度
      :deep(.el-form-item.is-required.asterisk-left) {
        margin-bottom: 16px;

        //字体
        .el-form-item__label {
          color: #000000;
          font-size: 14px;
          font-weight: 400;
        }
      }

      //textarea框
      :deep(.el-textarea__inner) {
        min-height: 76px !important;
        // border:1px solid red;
      }

      //手机验证码输入框
      :deep(.el-input.mobile-code) {
        width: 243px;
        .el-input__wrapper {
          border-right: transparent;
          border-radius: 4px 0px 0px 4px;
        }
      }

      //手机验证码按钮
      :deep(.el-button) {
        width: 100px;
        height: 40px;
        // margin-left: 7px;
        border: 1px solid #cacacd;
        border-left: none;
        background-color: #fbfbfb;
        border-radius: 0px 4px 4px 0px;
        > span {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
        }
      }
    }

    ///////已读勾选 与 提交按钮
    .last-box {
      // border: 1px solid red;
      margin: 0 auto;
      align-items: center;

      ////// 按钮
      :deep(.el-button.el-button--primary) {
        width: 343px;
        height: 40px;
        border-radius: 4px;
        // margin-left: 111px;

        > span {
          font-size: 14px;
          font-weight: 400;
        }
      }

      //已读勾选框
      :deep(.login-checkbox) {
        height: 20px;
        display: flex;
        align-items: center;
        margin-top: 12px;
        // margin-left: 111px;

        > span {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          color: #009de0;
        }
        > span:nth-of-type(2) {
          color: #606266;
        }
      }
    }
  }
}

////////弹窗（协议）
:deep(.el-dialog.agreement-box) {
  min-height: 500px;
}

:deep(.el-cascader) {
  width: 100%;
}

// :deep(.el-radio-group){
//   border:1px solid red;
// }
// :deep(.el-form-item__error){
//   border:1px solid red;
//   height:50px;
// }

// :deep(.el-form-item.is-error.is-required.asterisk-left.id-box.cs-box){
//   margin-top:20px;
// }
// :deep(.el-form-item.is-success.is-required.asterisk-left.id-box.cs-box){
//    margin-top:20px;
// }
//手机号验证或邮箱验证任选其一
:deep(.el-form-item.is-required.asterisk-left.id-box.cs-box) {
  margin-top: 20px;
  margin-bottom: 5px !important;
}

:deep(.last-box) {
  // border:1px solid red;
  .black-box {
    margin-bottom: 0px;
  }
  .white-box {
    display: none !important;
  }
}


//弹窗
:deep(.el-dialog) {
  border-radius: 8px;
}
</style>
